// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n", ""]);
// Exports
exports.locals = {
	"menuText": "#303133",
	"menuActiveText": "#3AC5A8",
	"subMenuActiveText": "#303133",
	"menuBg": "#ffffff",
	"menuHover": "#3ac5a8",
	"subMenuBg": "#ffffff",
	"sideMenuActive": "#3ac5a8",
	"subMenuHover": "#3ac5a8",
	"sideBarWidth": "240px"
};
module.exports = exports;
